import script from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./PaWorkspace.vue?vue&type=style&index=0&id=5dec5959&lang=scss&scoped=true"
import "./PaWorkspace.vue?vue&type=style&index=1&id=5dec5959&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dec5959"]])

export default __exports__